if (!customElements.get('nn-lounger-offer')) {
class NiuNiuLoungerOffer extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-offer-variants]').textContent);
    this.singles = this.variants.filter(v => !v.models?.length);
    this.section = this.closest('product-info');
    const selected = this.variants.find(v => v.id === this.dataset.selected) || this.singles[0];
    this.mode = selected.models?.length ? 'duo' : 'single';
    this.models = selected.models?.length ? [...selected.models] : [selected.id, selected.id];
    this.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) this.mode = event.target.value;
      if (event.target.matches('[data-model]')) this.models[Number(event.target.dataset.model) - 1] = event.target.value;
      this.sync();
    });
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-design]');
      if (!button) return;
      this.models[0] = button.dataset.design;
      this.sync();
    });
    customElements.whenDefined('product-form').then(() => {
      if (this.isConnected) this.sync(false);
    });
  }

  selectedVariant() {
    const key = [...this.models].sort().join('|');
    return this.mode === 'single'
      ? this.singles.find(v => v.id === this.models[0])
      : this.variants.find(v => v.models?.length === 2 && [...v.models].sort().join('|') === key);
  }

  syncHeader(variant, first, second, money) {
    const header = this.section.querySelector('[data-product-header]');
    if (!header) return;
    const comparison = this.mode === 'duo' ? first.price + second.price : variant?.comparePrice || 0;
    const onSale = !!variant && comparison > variant.price;
    const inStock = this.mode === 'duo' ? first.inStock && second.inStock : variant?.inStock;
    header.querySelector('[data-header-price]').textContent = variant?.money || '—';
    const compare = header.querySelector('[data-header-compare]');
    compare.hidden = !onSale;
    compare.textContent = money(comparison);
    header.querySelector('[data-header-comparison-note]').hidden = this.mode !== 'duo' || !onSale;
    header.querySelector('[data-header-shipping]').hidden = !(variant?.available && Number(header.dataset.shippingThreshold) > 0 && variant.price >= Number(header.dataset.shippingThreshold));
    header.querySelector('[data-header-stock]').dataset.available = String(!!variant?.available);
    header.querySelector('[data-header-stock-label]').textContent = variant?.available ? (inStock ? header.dataset.inStock : header.dataset.available) : header.dataset.unavailable;
  }

  sync(updateUrl = true) {
    const variant = this.selectedVariant();
    const first = this.singles.find(v => v.id === this.models[0]);
    const second = this.singles.find(v => v.id === this.models[1]);
    const duo = this.variants.find(v => v.models?.length === 2 && [...v.models].sort().join('|') === [...this.models].sort().join('|'));
    this.querySelectorAll('[data-offer-card]').forEach(card => card.classList.toggle('is-selected', card.dataset.offerCard === this.mode));
    this.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.value === this.mode);
    this.querySelector('[data-duo-details]')?.toggleAttribute('hidden', this.mode !== 'duo');
    this.querySelectorAll('[data-model]').forEach(select => select.value = this.models[Number(select.dataset.model) - 1]);
    this.querySelectorAll('[data-design]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.design === first.id)));
    this.querySelector('[data-design-name]').textContent = first.title;
    this.querySelector('[data-single-price]').textContent = first.money;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency', currency:this.dataset.currency}).format(cents / 100);
    this.syncHeader(variant, first, second, money);
    if (duo) {
      this.querySelector('[data-duo-price]').textContent = duo.money;
      this.querySelector('[data-compare]').textContent = money(first.price + second.price);
      this.querySelector('[data-saving]').textContent = window.nnUi.duo_saving.replace('[amount]', money(first.price + second.price - duo.price));
    }
    const form = this.section.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const id = form.querySelector('input[name="id"]');
    id.value = variant?.id || '';
    id.dispatchEvent(new Event('change', {bubbles:true}));
    const gift = this.querySelector('[data-gift-property]');
    gift.disabled = this.mode !== 'duo';
    gift.value = variant?.gift || '';
    const contents = this.querySelector('[data-models-property]');
    contents.disabled = this.mode !== 'duo';
    contents.value = window.nnUi.duo_contents.replace('[first]', first.title).replace('[second]', second.title);
    this.section.querySelector('product-form')?.toggleSubmitButton?.(!variant?.available, variant?.available ? undefined : window.variantStrings.unavailable);
    const payment = form.querySelector('.shopify-payment-button');
    if (payment) payment.hidden = !variant?.available;
    this.querySelector('[data-offer-status]').textContent = variant?.available ? `${this.mode === 'duo' ? contents.value + '. ' + gift.value : first.title}. ${variant.money}` : window.nnUi.combination_unavailable;
    if (!variant) return;
    this.section.querySelectorAll('[id^="price-"] .price-item').forEach(price => price.textContent = variant.money);
    const gallery = this.section.querySelector('nn-gallery');
    if (gallery) {
      gallery.querySelectorAll('[data-gallery-slide="variant"] img, [data-gallery-index="variant"] img').forEach(img => { img.removeAttribute('srcset'); img.src = first.image; img.alt = first.title; });
      const thumb = gallery.querySelector('[data-gallery-index="variant"]');
      if (thumb) { thumb.setAttribute('aria-label', first.title); if(updateUrl) thumb.click(); }
    }
    if (updateUrl && this.section.dataset.updateUrl !== 'false') {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }
}
customElements.define('nn-lounger-offer', NiuNiuLoungerOffer);
}
